export const RECRUITMENT_DETAIL = "RECRUITMENT_DETAIL";
export const RECRUITMENT_LIST = "RECRUITMENT_LIST";
export const CURRENT_PAGE = "CURRENT_PAGE";

export default {
    RECRUITMENT_DETAIL,
    RECRUITMENT_LIST,
    CURRENT_PAGE
};
